module.exports = __webpack_public_path__ + "02_veryshort_gray.2c7c1731.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/02_veryshort_gray.png
// module id = 6GLH
// module chunks = 0